<template>
    <div class="Field__Component">
        <div>
            <slot>
                <div @click="copyToClipboard" class="copy-link-button" :title="'העתק קישור'">
                    <b-icon pack="fa" icon="copy"></b-icon>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
import { ToastProgrammatic as Toast } from 'buefy';

export default {
    name: 'FieldCopyLink',
    props: ['value', 'item'],
    methods: {
        async copyToClipboard() {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    // Use the modern clipboard API
                    await navigator.clipboard.writeText(this.value);
                } else {
                    // Fallback for older browsers or non-secure contexts
                    const textArea = document.createElement('textarea');
                    textArea.value = this.value;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    document.execCommand('copy');
                    textArea.remove();
                }
                
                Toast.open({
                    type: 'is-success',
                    message: 'הקישור הועתק ללוח!',
                    duration: 3000,
                });
            } catch (error) {
                Toast.open({
                    type: 'is-danger',
                    message: 'שגיאה בהעתקת הקישור',
                    duration: 4000,
                });
            }
        }
    }
};
</script>

<style scoped>
.Field__Component .copy-link-button {
    cursor: pointer;
    color: #00427e !important;
    transition: color 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 3px;
}

.Field__Component .copy-link-button:hover {
    color: #0091ae !important;
    background-color: rgba(0, 66, 126, 0.1);
}

.Field__Component .copy-link-button:active {
    transform: scale(0.95);
}
</style>
